import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MdLogin,
  MdOutlineAccountBalanceWallet,
  MdOutlineSupervisorAccount,
  MdMenu,
  MdClose,
  MdCardMembership,
  MdOutlinePointOfSale,
} from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { CiSettings } from "react-icons/ci";
import avatarImg from "../../images/shapes/Profile_Logo 1.png";
import LogoutModal from "../RetailerBusinessAgent/LogoutModal";

function SideBar({ user }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleNavClick = () => {
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  return (
    <>
      <aside className={`sidebar_container1 ${mobileOpen ? "expanded" : ""}`}>
        {/* Profile Header */}
        <div className="profile1">
          <img
            src={user?.avatar || avatarImg}
            alt="Profile"
            className="profile-img1"
          />

          <div className="profile-info1">
            <h3 className="profile-name1">{user?.fullName || "User"}</h3>
            <p className="profile-role1">Trading As {user?.retailName}</p>
          </div>

          <button
            className="sidebar-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <MdClose /> : <MdMenu />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-content">
          <ul className="menu1">
            <li>
              <NavLink
                to="/retail-business/wallet"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdOutlineAccountBalanceWallet className="icon1" />
                Wallets
              </NavLink>
            </li>

            <li>
              <NavLink to="/retail-business/card-collection" className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}>
                <MdCardMembership className="icon1" />
                Premium Card Collection
              </NavLink>
            </li>

            {/* <li>
              <NavLink
                to="/retail-business/transaction-window"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdOutlinePointOfSale className="icon1" />
                Transaction
              </NavLink>
            </li> */}

            {/* <li>
              <NavLink
                to="#"
                className="menu-link1"
                onClick={(e) => {
                  e.preventDefault();
                  alert("Profile page coming soon!");
                }}
              >
                <CgProfile className="icon1" />
                Profile
              </NavLink>
            </li> */}
          </ul>

          <div className="bottom-menu1">
            <hr />
            {/* <button
              className="logout-btn1"
              onClick={(e) => {
                e.preventDefault();
                alert("Settings page coming soon!");
              }}
            >
              <CiSettings className="icon1" /> Settings
            </button> */}
            <button
              className="logout-btn1"
              onClick={() => setShowLogoutModal(true)}
            >
              <MdLogin className="icon1" /> Logout
            </button>
          </div>
        </nav>
      </aside>

      {showLogoutModal && (
        <LogoutModal user={user} onClose={() => setShowLogoutModal(false)} />
      )}
    </>
  );
}

export default React.memo(SideBar);
